import React from 'react';
import { Col, Modal, Row } from 'react-bootstrap';
import styles from './viewModal.module.scss';

const ViewModal = ({ showGlobalViewModal, setShowGlobalViewModal, modalSize, titel, content }) => {
    return (
        <Modal
            centered
            show={showGlobalViewModal}
            onHide={() => setShowGlobalViewModal(false)}
            size={modalSize || 'xl'}
            className="viewWrapper"
        >
            <Modal.Header>
                <h4 className="modal-title" id="exampleModalLabel">
                    View Details:
                </h4>
                <button
                    type="button"
                    className="btn-close"
                    onClick={() => setShowGlobalViewModal(false)}
                ></button>
            </Modal.Header>
            <Modal.Body>
                <Row>
                    {titel && titel.map((header, index) => (
                        <Col xl={modalSize === 'lg' ? 4 : 3} lg={4} xs={6} sm={12} className="mb-4" key={index}>
                            <p className="fs-15 mb-1">{header?.title}</p>
                            <h5 className={styles.value}>
                                {content && (typeof content[header?.key] === 'object' && content[header?.key] !== null
                                    ? content[header?.key]?.name || 'N/A'
                                    : content[header?.key] || 'N/A')}
                            </h5>
                        </Col>
                    ))}
                </Row>
            </Modal.Body>
        </Modal>
    );
};

export default ViewModal;